var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"summary-label colorNeutralsNavy500--text"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"summary-value colorNeutralsNavy400--text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }